
import React from 'react';
import TopContactBar from './TopContactBar';
import Navbar from './Navbar';
import './Navbar.css'; 

const Header = () => {
  return (
    <header>
      <TopContactBar />
      <Navbar />
    </header>
  );
};

export default Header;